import { DateTime } from 'luxon';

const luxonDisplayDates = (startDate: DateTime, endDate: DateTime | null) => {
  if (!startDate) {
    return null;
  }

  if (!endDate) {
    return startDate.toFormat('MMM d');
  }

  if (startDate.hasSame(endDate, 'day')) {
    return startDate.toFormat('MMM do');
  } else if (startDate.year !== endDate.year) {
    return `${startDate.toFormat('MMM d, yyyy')}－${endDate.toFormat('MMM d, yyyy')}`;
  } else if (startDate.month !== endDate.month) {
    return `${startDate.toFormat('MMM d')}－${endDate.toFormat('MMM d')}`;
  } else {
    return `${startDate.toFormat('MMM d')}－${endDate.toFormat('d')}`;
  }
};

export default luxonDisplayDates;